/**
 * OmyBoat — Ports Utils
 * Fonctions pures : géo, geocoding, helpers DOM
 * Dépend de : rien (chargé en premier)
 */

(function () {
  'use strict';

  // ── Haversine ──────────────────────────────────────────────────────────────
  window.portsHav = function (lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
          + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180)
          * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * 10) / 10;
  };

  // ── Villes proches ─────────────────────────────────────────────────────────
  window.portsNearbyCities = function (lat, lng, radius) {
    var villes = window.OMYBOAT_VILLES_META || [];
    return villes.map(function (c) {
      return Object.assign({}, c, { dist: window.portsHav(lat, lng, c.lat, c.lng) });
    }).filter(function (c) {
      return c.dist <= radius;
    }).sort(function (a, b) {
      return a.dist - b.dist;
    });
  };

  // ── Photon geocoding ───────────────────────────────────────────────────────
  window.portsGeocode = function (query, cb) {
    var url = 'https://photon.komoot.io/api/?q=' + encodeURIComponent(query)
            + '&limit=3&lang=fr&bbox=4.5,42.5,8.0,44.5';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var results = (d.features || []).map(function (f) {
          return {
            lat:   f.geometry.coordinates[1],
            lng:   f.geometry.coordinates[0],
            label: f.properties.name || f.properties.city || query,
          };
        }).filter(function (r) { return r.lat && r.lng; });
        cb(null, results);
      })
      .catch(function (e) { cb(e, []); });
  };

  // ── Highlight texte ────────────────────────────────────────────────────────
  window.portsHighlight = function (text, q) {
    if (!q || q.length < 2) return text;
    var escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark>$1</mark>');
  };

  // ── Escape quote ───────────────────────────────────────────────────────────
  window.portsEsc = function (s) {
    return s.replace(/'/g, "\\'");
  };

  // ── Spinner ────────────────────────────────────────────────────────────────
  window.portsShowSpinner = function (v) {
    var el = document.getElementById('portsSpinner');
    if (el) el.classList.toggle('visible', v);
  };

})();
